import AppSearchPageMixin from "@/protected/mixins/AppSearchPageMixin";
import pluralize from "pluralize";

export default {
  mixins: [AppSearchPageMixin],

  methods: {
    /*
    initParameters() {
      return {
        statusId:
          this.$route.query && this.$route.query.statusId
            ? [this.$route.query.statusId]
            : undefined
      };
    },
    */

    filePage() {
      // 'CreditAssignmentFiles' -> 'CreditAssignmentFile'
      const routeName = this.$route.name;
      return pluralize.singular(routeName);
    },

    onAdd() {
      this.$router.push({
        name: this.filePage(),
        params: { id: "new" }
      });
    },

    variantFor(s) {
      switch (s.type) {
        case "INITIAL":
          return "info";
        case "INTERMEDIATE":
          return "warning";
        case "SUCCESS":
          return "success";
        case "FAILURE":
          return "danger";
      }
      throw Error("Unsupported type");
    }
  }
};
